<template>
  <div v-if="localDateFacet && localDateFacet.categories" class="ypo-event-date">
    <v-layout column wrap v-for="(dateFilter, idx) in localDateFacet.categories"
              v-if="dateFilter.count"
              :key="idx">
      <v-flex xs12 ml-3 class="filter-category">
        <label :class="['check-container', 'check-container--radio', 'ypo_blue_color']">
          <v-layout>
            <v-flex class="check-container--label"
                    :data-qe-id="`date-facet_option-${idx}`">
              <span :class="[isActive(dateFilter) ? 'checked-option' : '']">{{dateFilter.label}}</span>
            </v-flex>
          </v-layout>
          <input type="radio"
                 :value="dateFilter"
                 v-model="selectedDateFilter"
                 @click="apply(dateFilter)"
                 :data-qe-id="`date-facet_option-${idx}_input`">
          <span class="checkmark" :class="[isActive(dateFilter) ? 'checked-checkbox' : '']"></span>
        </label>
      </v-flex>
    </v-layout>
    <v-layout column>
      <v-flex xs12 v-if="localDateFacet.categories.length">
        <v-layout column wrap ml-4>
          <v-flex ml-3 :class="['ypo-event-date__date-range', dateFrom ? 'ypo-event-date__date-range--selected' : '']">
            <v-menu ref="dateMenuFrom"
                    :close-on-content-click="false" class="calander-icon"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    max-width="290px">
              <v-text-field slot="activator"
                            v-model="dateFrom"
                            :prepend-inner-icon="!dateFrom ? 'event' : ''"
                            :data-qe-id="`date-facet_option_date-from`"
                            placeholder="From Date"
                            ref="dateMenuFromInput"
                            required
                            readonly></v-text-field>
              <v-date-picker ref="picker"
                             v-model="dateFrom"
                             :show-current="false"
                             :min="minStartDate"
                             @change="applyDate"></v-date-picker>
            </v-menu>
          </v-flex><v-flex ml-3 :class="['ypo-event-date__date-range', dateTo ? 'ypo-event-date__date-range--selected' : '']">
            <v-menu ref="dateMenuTo"
                    :close-on-content-click="false" class="calander-icon"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    :disabled="!dateFrom"
                    min-width="290px"
                    max-width="290px">
              <v-text-field slot="activator"
                            v-model="dateTo"
                            :disabled="!dateFrom"
                            :prepend-inner-icon="!dateTo ? 'event' : ''"
                            :data-qe-id="`date-facet_option_date-to`"
                            placeholder="To Date"
                            required
                            readonly></v-text-field>
              <v-date-picker ref="picker"
                             v-model="dateTo"
                             :show-current="dateFrom"
                             :min="minEndDate"
                             @change="applyDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex></v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {getFilteredString, ypoEventConstant} from "@/components/YpoEvents/ypoEvents.constant";
import { addDays } from "@/common/utils/dateTime";
import {gaDataLayerEvent} from "@/plugins/analytics";
import {gtmEventName} from "@/plugins/gtmAnalytics";

export default {
  name: 'YpoEventsDateFilter',
  props: {
    dateFilterFacet: {
      type: Object,
      required: true,
    },
    appliedDateFilters: {
      type: Array,
      required: true,
      default: () => [],
    },
    allAppliedFilters: {
      type: Object,
    },
    setMostRecentFacetInState: {
      type: Function,
      required: true,
    },
  },
  created() {
    if (this.appliedDateFilters && this.appliedDateFilters.length) {
      const hasStartDateRange = this.appliedDateFilters.find(filter => filter.filterKey
          && filter.filterKey.toLowerCase() === ypoEventConstant.constant.keys.startDateTimeRangeFrom.toLowerCase());
      const hasEndDateRange = this.appliedDateFilters.find(filter => filter.filterKey
          && filter.filterKey.toLowerCase() === ypoEventConstant.constant.keys.startDateTimeRangeTo.toLowerCase());

      if (hasStartDateRange && hasEndDateRange) {
        this.selectedDateFilter = { ...ypoEventConstant.dateFilters.dateRange };
        this.dateFrom = new Date(hasStartDateRange.filterValue).toISOString().substr(0, 10);
        this.dateTo = new Date(hasEndDateRange.filterValue).toISOString().substr(0, 10);
      } else {
        this.selectedDateFilter = { ...this.appliedDateFilters[0] };
      }
    } else {
      this.selectedDateFilter = { ...ypoEventConstant.dateFilters.defaultFilter };
    }
  },
  data() {
    return {
      ypoEventConstant,
      selectedDateFilter: null,
      dateFrom: null,
      dateTo: null,
    };
  },
  methods: {
    isActive(filter) {
      return !!(filter && this.selectedDateFilter && filter.filterValue === this.selectedDateFilter.filterValue);
    },
    apply(filterItem) {
      if (filterItem) {
        if (filterItem.filterKey === ypoEventConstant.dateFilters.dateRange.filterKey) {
          this.$refs.dateMenuFromInput.$el.click();
        } else if (this.appliedDateFilters
            && !this.appliedDateFilters.find(filter => filter.label === filterItem.label)) {
          const newFilters = this.allAppliedFilters ? { ...this.allAppliedFilters } : {};

          if (filterItem.filterValue === ypoEventConstant.dateFilters.defaultFilter.filterValue) {
            newFilters.dates = [];
          } else {
            newFilters.dates = [{ ...filterItem }];
          }

          const gtmFilters = getFilteredString(newFilters) ;
          gaDataLayerEvent(gtmEventName.C_Event_Search_Filters, gtmFilters);

          this.$router.push({
            query: {
              ...this.$route.query,
              eventFilters: JSON.stringify(newFilters),
            },
          });
        }
      }
    },
    applyDate() {
      if (this.dateFrom && this.$refs && this.$refs.dateMenuFrom && this.$refs.dateMenuFrom.save) {
        this.$refs.dateMenuFrom.save(this.dateFrom);
      }
      if (this.dateFrom && this.dateTo) {
        const dateRangeStart = {
          ...ypoEventConstant.dateFilters.dateRangeStartFilter,
          filterValue: this.dateFrom,
        };

        const dateRangeEnd = {
          ...ypoEventConstant.dateFilters.dateRangeEndFilter,
          filterValue: this.dateTo,
        };
        const newFilters = this.allAppliedFilters ? { ...this.allAppliedFilters } : {};
        newFilters.dates = [dateRangeStart, dateRangeEnd];

        this.$router.push({
          query: {
            ...this.$route.query,
            eventFilters: JSON.stringify(newFilters),
          },
        });
      }
    },
  },
  computed: {
    localDateFacet() {
      let result = [];
      if (this.dateFilterFacet && this.dateFilterFacet.categories && this.dateFilterFacet.categories.length) {
        result = {
          ...this.dateFilterFacet,
          categories: [
            { ...ypoEventConstant.dateFilters.defaultFilter },
            ...this.dateFilterFacet.categories,
            { ...ypoEventConstant.dateFilters.dateRange },
          ],
        };
      }
      return result;
    },
    minEndDate() {
      return this.dateFrom
          ? new Date(addDays(new Date(this.dateFrom), 1)).toISOString().substr(0, 10)
          : new Date().toISOString().substr(0, 10);
    },
    minStartDate() {
      return new Date(Date.now() + (-1095 * 24 * 60 * 60 * 1000)).toISOString().substr(0, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';
@import '../../common/styles/_commonClasses.scss';

.ypo-event-date {
  .filter-category {
    @extend %ypo-secondary-checkbox;
  }

  .check-container--no-margin-bottom {
    margin-bottom: 0 !important;
  }

  &__selections {
    font-size: 12px !important;
    padding-top: 0;
    margin-top: 0;

    .v-select__selection {
      margin: 0 !important;
    }
  }
}

</style>
<style lang="scss">
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';
@import '../../common/styles/_commonClasses.scss';

.ypo-event-date {
  .v-select__selection--comma {
    margin-bottom: 0 !important;
    margin-left: 5px !important;
    text-transform: capitalize!important;
  }

  .theme--light.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before {
    border-image: none !important;
  }

  .v-select.v-text-field input {
    padding: 0 !important;
  }

  .v-menu__content {
    @extend %inner-scrollbar;
  }

  .v-list__tile {
    text-transform: capitalize;
  }

  &__date-range {
    width: 80px;
    margin-top: -7px;

    .v-input {
      padding: 0;
      margin: 0;
    }
    .v-icon {
      font-size: 12px;
      position: absolute;
      left: 0;
      bottom: 3px;
    }

    .v-input__prepend-inner {
      width: 15px;
    }

    .v-text-field__slot {
      font-size: 12px;
      padding-left: 2px;

      input {
        padding-bottom: 0;
      }
    }

    &--selected {
      width: 65px;
    }
  }

}
</style>
